// @ag-grid-community/react v31.0.3
import { createContext } from "react";
export const CustomContext = createContext({
    setMethods: () => { },
});
